<div class="blank-container">
  <div *ngFor="let field of options?.structure">
    <div class="blank-item" *ngIf="field.type !== 'full-table' && field.type !== 'title'" [ngStyle]="{ 'font-size.px': fontSize, 'line-height': lineHeight}"
         [ngClass]="field.type">
      <div class="item-container"
           [class.show-empty]="showEmptyRow(options.data[item?.field])"
           [ngClass]="item?.class || field?.align"
           *ngFor="let item of field?.items">
            <div class="title"
                 [class.strong-titles]="strongTitles">
              {{ item?.title }}
            </div>
            <div class="value"
                 [class.bottom-border]="borderValue">
              {{ options.data[item?.field] }}
            </div>
      </div>
    </div>
    <div class="center-title text-center text-{{field?.align}}" *ngIf="field.type === 'title'">
      <strong *ngFor="let item of field?.items">{{ item?.title }}</strong>
    </div>
    <table class="table table-compact" *ngIf="field.type === 'full-table'">
      <thead>
        <tr>
          <th *ngFor="let header of field?.table_headers" [ngClass]="header?.class">
            {{ header.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rows of field.table_rows">
          <td *ngFor="let cols of rows" [ngClass]="cols?.class">
            {{ cols?.title ? cols?.title : options.data[cols?.field] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
